import Tooltip from '@mui/material/Tooltip/Tooltip'
import { ReactElement } from 'react'

interface Props {
  hasTooltip: boolean
  title: string
  children: ReactElement
}

export const WithTooltip = ({ hasTooltip, title, children }: Props) => {
  if (!hasTooltip) {
    return children
  }

  return (
    <Tooltip title={title}>
      <span>{children}</span>
    </Tooltip>
  )
}
